import React from 'react'
import './FooterLGPD.scss'

const FooterLGPD = ({ handleAcceptLGPD }) => {
  return (
    <div className='footer-lgpd'>
      <p>
        PALEX MEDICAL, S.A.U. como responsable del tratamiento tratará tus datos
        con la finalidad de remitirte el Catálogo Digital.
        <br />
        Puedes acceder, rectificar y suprimir tus datos, así como ejercer otros
        derechos consultando la información adicional y detallada sobre
        protección de datos en nuestra <a target="_blank" href="https://palexhealth.vercel.app/es-es/privacy-policy">Política de Privacidad</a>
      </p>
      <p style={{ verticalAlign: 'middle', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
        <input name='isCheckedLGPD' onClick={handleAcceptLGPD} type='checkbox' style={{ marginRight: '0.5rem'}} required />
        He leído y acepto las condiciones contenidas en la política de mis datos para el envío del Catálogo Digital.
      </p>

    </div>
  )
}

export default FooterLGPD
